import { acceptHMRUpdate, defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { useStorage } from '@vueuse/core'

export type UserData = Record<string, any> | null | any

export const useUserSession = defineStore('userSession', () => {
  // token will be synced with local storage
  // @see https://vueuse.org/core/usestorage/
  const token = useStorage('token', '')
  const refreshToken = useStorage('refresh_token', '')
  const modalSubStorage = localStorage.getItem('show_subscription');
  const showModalSubscription = useStorage('show_subscription', modalSubStorage === 'false' ? false : true)

  const user = ref<Partial<UserData> | any>()
  const loading = ref(true)
  const isApk = useStorage('apk', false)
  // const isApk = ref(false)

  const isLoggedIn = computed(() => 
    (token.value !== undefined && token.value !== '') || 
    (refreshToken.value !== undefined && refreshToken.value !== '')
  )

  function setUser(newUser: Partial<UserData>): void {
    user.value = newUser
  }

  function setToken(newToken: string): void {
    token.value = newToken
  }

  function setRefreshToken(newRefreshToken: string): void {
    refreshToken.value = newRefreshToken
  }

  function setLoading(newLoading: boolean): void {
    loading.value = newLoading
  }

  function setApk(newApk: boolean): void {
    isApk.value = newApk
  }

  async function logoutUser(): Promise<void> {
    token.value = undefined
    refreshToken.value = undefined
    user.value = undefined
  }

  function isUserSubscribe(): boolean {
    return user.value?.package?.subscription_type !== 'free' || false
  }

  function getUserPackage(): Record<string, any> {
    return user.value.package
  }

  function setShowModalSubscription(newShowModalSubscription: boolean): void {
    showModalSubscription.value = newShowModalSubscription
  }

  return {
    user,
    token,
    refreshToken,
    isLoggedIn,
    loading,
    isApk,
    showModalSubscription,
    logoutUser,
    setUser,
    setToken,
    setRefreshToken,
    setLoading,
    setApk,
    isUserSubscribe,
    getUserPackage,
    setShowModalSubscription
  } as const
})

/**
 * Pinia supports Hot Module replacement so you can edit your stores and
 * interact with them directly in your app without reloading the page.
 *
 * @see https://pinia.esm.dev/cookbook/hot-module-replacement.html
 * @see https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useUserSession, import.meta.hot))
}